export default __webpack_public_path__ + "static/10-03d6702ce34a57567adfb7a3ce3f872e.jpg";